/**
 * Chat Layout Component
 *
 * Purpose: Provides the main layout container for the chat interface.
 *
 * How it works:
 * 1. Creates a fixed, full-viewport container for the chat application
 * 2. Uses React Router's Outlet to render nested route components
 * 3. Applies responsive styling with Tailwind classes
 *
 * Key features:
 * - Fixed positioning for viewport stability
 * - Responsive layout with different behavior on desktop/mobile
 * - Serves as the parent container for all chat-related components
 */

import { useEffect } from "react";
import { useChatRouteSync } from "@/useChatRouteSync";
import { setNavigateRef } from "@/lib/navigationRef";
import { Outlet, useNavigate } from "react-router-dom";

const ChatLayout = () => {
  useChatRouteSync();
  const navigate = useNavigate();
  useEffect(() => {
    setNavigateRef(navigate);
  }, [navigate]);
  return (
    <main
      id="Main"
      className="fixed left-0 top-0 h-[var(--app-height,100dvh)] w-screen pt-[env(safe-area-inset-top,0px)] transition-[height] duration-200 ease-out motion-reduce:transition-none lg:flex"
    >
      <Outlet />
    </main>
  );
};

export default ChatLayout;
